import styled from "styled-components";

export const NavbarStyled = styled.div`
  padding: 28px 24px 10px 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  box-shadow: 0px 1px 4px 0px rgba(12, 12, 13, 0.05),
    0px 1px 4px 0px rgba(12, 12, 13, 0.1);
  .navbar_left {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .logo {
    margin-bottom: 17px;
    cursor: pointer;
  }
  .navbar_right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
`;
